import styled from 'styled-components';

export default styled.div`
  .ant-form-item-label {
    font-weight: bold;
  }
`;
